// @file Sets up vue app for the SurfaceProtectedWhiteboardEmbed page.
// Tagged with `source: 'sandbox'` so Sentry events from this embed are
// filterable alongside the main Sandbox/Whiteboard page (PRO-30444).
import { captureException, SANDBOX_SOURCE_TAG_VALUE } from '@@/bits/error_tracker'
import window, { ww } from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import App from '@@/vuecomponents/SurfaceProtectedWhiteboardEmbed.vue'

setupVueApp({
  el: '#surface_protected_whiteboard_embed',
  rootComponent: App,
  usePinia: true,
  errorTrackingSource: SANDBOX_SOURCE_TAG_VALUE,
  rootComponentProps: () => ({
    showUrl: ww.vueStartingState.showUrl,
    title: ww.vueStartingState.title,
    description: ww.vueStartingState.description,
  }),
})
  .then((vueInstance) => {
    window.app = vueInstance
  })
  .catch(captureException)
